/* eslint-disable  @typescript-eslint/no-explicit-any, camelcase */
/* Generated types. Do not edit by hand */
import * as Types from 'src/graphql.generated'

import { gql } from '@apollo/client'
import * as Apollo from '@apollo/client'

const defaultOptions = {} as const
export type GetAdvancedSymptomSurveyAssignmentsQueryVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
}>

export type GetAdvancedSymptomSurveyAssignmentsQuery = {
  __typename?: 'Query'
  patientQuestionnaireAssignments: Array<{
    __typename?: 'QuestionnaireAssignment'
    assignmentID: string
    questionnaire: Types.AssignableQuestionnaire
    assignedAt: Date
    completedAt?: Date | null
    dueAt: Date
    repeatCadenceInDays?: number | null
  }>
}

export type AssignAdvancedSymptomSurveyMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  questionnaire: Types.AssignableQuestionnaire
  repeatCadenceInDays?: Types.InputMaybe<Types.Scalars['Int']['input']>
}>

export type AssignAdvancedSymptomSurveyMutation = {
  __typename?: 'Mutation'
  assignQuestionnaireToPatient: {
    __typename?: 'QuestionnaireAssignment'
    assignmentID: string
    questionnaire: Types.AssignableQuestionnaire
    assignedAt: Date
    completedAt?: Date | null
    dueAt: Date
    repeatCadenceInDays?: number | null
  }
}

export type RemoveAdvancedSymptomSurveyAssignmentMutationVariables = Types.Exact<{
  uid: Types.Scalars['ID']['input']
  assignmentID: Types.Scalars['ID']['input']
}>

export type RemoveAdvancedSymptomSurveyAssignmentMutation = {
  __typename?: 'Mutation'
  removeQuestionnaireAssignment?: null | null
}

export const GetAdvancedSymptomSurveyAssignmentsDocument = gql`
  query getAdvancedSymptomSurveyAssignments($uid: ID!) {
    patientQuestionnaireAssignments(uid: $uid) {
      assignmentID
      questionnaire
      assignedAt
      completedAt
      dueAt
      repeatCadenceInDays
    }
  }
`

/**
 * __useGetAdvancedSymptomSurveyAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetAdvancedSymptomSurveyAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdvancedSymptomSurveyAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdvancedSymptomSurveyAssignmentsQuery({
 *   variables: {
 *      uid: // value for 'uid'
 *   },
 * });
 */
export function useGetAdvancedSymptomSurveyAssignmentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAdvancedSymptomSurveyAssignmentsQuery,
    GetAdvancedSymptomSurveyAssignmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<GetAdvancedSymptomSurveyAssignmentsQuery, GetAdvancedSymptomSurveyAssignmentsQueryVariables>(
    GetAdvancedSymptomSurveyAssignmentsDocument,
    options
  )
}
export function useGetAdvancedSymptomSurveyAssignmentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAdvancedSymptomSurveyAssignmentsQuery,
    GetAdvancedSymptomSurveyAssignmentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<
    GetAdvancedSymptomSurveyAssignmentsQuery,
    GetAdvancedSymptomSurveyAssignmentsQueryVariables
  >(GetAdvancedSymptomSurveyAssignmentsDocument, options)
}
export type GetAdvancedSymptomSurveyAssignmentsQueryHookResult = ReturnType<
  typeof useGetAdvancedSymptomSurveyAssignmentsQuery
>
export type GetAdvancedSymptomSurveyAssignmentsLazyQueryHookResult = ReturnType<
  typeof useGetAdvancedSymptomSurveyAssignmentsLazyQuery
>
export type GetAdvancedSymptomSurveyAssignmentsQueryResult = Apollo.QueryResult<
  GetAdvancedSymptomSurveyAssignmentsQuery,
  GetAdvancedSymptomSurveyAssignmentsQueryVariables
>
export const AssignAdvancedSymptomSurveyDocument = gql`
  mutation assignAdvancedSymptomSurvey($uid: ID!, $questionnaire: AssignableQuestionnaire!, $repeatCadenceInDays: Int) {
    assignQuestionnaireToPatient(uid: $uid, questionnaire: $questionnaire, repeatCadenceInDays: $repeatCadenceInDays) {
      assignmentID
      questionnaire
      assignedAt
      completedAt
      dueAt
      repeatCadenceInDays
    }
  }
`
export type AssignAdvancedSymptomSurveyMutationFn = Apollo.MutationFunction<
  AssignAdvancedSymptomSurveyMutation,
  AssignAdvancedSymptomSurveyMutationVariables
>

/**
 * __useAssignAdvancedSymptomSurveyMutation__
 *
 * To run a mutation, you first call `useAssignAdvancedSymptomSurveyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignAdvancedSymptomSurveyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignAdvancedSymptomSurveyMutation, { data, loading, error }] = useAssignAdvancedSymptomSurveyMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      questionnaire: // value for 'questionnaire'
 *      repeatCadenceInDays: // value for 'repeatCadenceInDays'
 *   },
 * });
 */
export function useAssignAdvancedSymptomSurveyMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AssignAdvancedSymptomSurveyMutation,
    AssignAdvancedSymptomSurveyMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<AssignAdvancedSymptomSurveyMutation, AssignAdvancedSymptomSurveyMutationVariables>(
    AssignAdvancedSymptomSurveyDocument,
    options
  )
}
export type AssignAdvancedSymptomSurveyMutationHookResult = ReturnType<typeof useAssignAdvancedSymptomSurveyMutation>
export type AssignAdvancedSymptomSurveyMutationResult = Apollo.MutationResult<AssignAdvancedSymptomSurveyMutation>
export type AssignAdvancedSymptomSurveyMutationOptions = Apollo.BaseMutationOptions<
  AssignAdvancedSymptomSurveyMutation,
  AssignAdvancedSymptomSurveyMutationVariables
>
export const RemoveAdvancedSymptomSurveyAssignmentDocument = gql`
  mutation removeAdvancedSymptomSurveyAssignment($uid: ID!, $assignmentID: ID!) {
    removeQuestionnaireAssignment(uid: $uid, assignmentID: $assignmentID)
  }
`
export type RemoveAdvancedSymptomSurveyAssignmentMutationFn = Apollo.MutationFunction<
  RemoveAdvancedSymptomSurveyAssignmentMutation,
  RemoveAdvancedSymptomSurveyAssignmentMutationVariables
>

/**
 * __useRemoveAdvancedSymptomSurveyAssignmentMutation__
 *
 * To run a mutation, you first call `useRemoveAdvancedSymptomSurveyAssignmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdvancedSymptomSurveyAssignmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdvancedSymptomSurveyAssignmentMutation, { data, loading, error }] = useRemoveAdvancedSymptomSurveyAssignmentMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      assignmentID: // value for 'assignmentID'
 *   },
 * });
 */
export function useRemoveAdvancedSymptomSurveyAssignmentMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAdvancedSymptomSurveyAssignmentMutation,
    RemoveAdvancedSymptomSurveyAssignmentMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    RemoveAdvancedSymptomSurveyAssignmentMutation,
    RemoveAdvancedSymptomSurveyAssignmentMutationVariables
  >(RemoveAdvancedSymptomSurveyAssignmentDocument, options)
}
export type RemoveAdvancedSymptomSurveyAssignmentMutationHookResult = ReturnType<
  typeof useRemoveAdvancedSymptomSurveyAssignmentMutation
>
export type RemoveAdvancedSymptomSurveyAssignmentMutationResult =
  Apollo.MutationResult<RemoveAdvancedSymptomSurveyAssignmentMutation>
export type RemoveAdvancedSymptomSurveyAssignmentMutationOptions = Apollo.BaseMutationOptions<
  RemoveAdvancedSymptomSurveyAssignmentMutation,
  RemoveAdvancedSymptomSurveyAssignmentMutationVariables
>
